// extracted by mini-css-extract-plugin
export default {"sectionFlex":"Pagination_sectionFlex__Y4KJM","btn":"Pagination_btn__Cg1HD"};